import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

const partners = [
  { name: "Warner Bros. Discovery", url: "https://wbd.com/" },
  { name: "Paramount", url: "https://www.paramount.com" },
  { name: "New Regency", url: "https://www.newregency.com" },
  { name: "A24", url: "https://www.a24films.com" },
  { name: "AMC Networks", url: "https://www.amcnetworks.com" },
  { name: "France Télévisions", url: "https://www.francetelevisions.fr" },
  { name: "MBS (Mainichi Broadcasting System)", url: "https://www.mbs.jp" },
  { name: "TWIN ENGINE", url: "https://twinengine.jp" },
  { name: "TOHO", url: "https://toho.co.jp" },
  { name: "KADOKAWA", url: "https://www.kadokawa.co.jp" },
  { name: "REMOW", url: "https://remow.com" },
  { name: "Kodansha", url: "https://www.kodansha.co.jp" },
  { name: "Fremantle", url: "https://fremantle.com" },
  { name: "ITV", url: "https://itv.com" },
  { name: "Fifth Season", url: "https://fifthseason.com" },
];

class PartnersSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div
        id="services"
        style={{ paddingBottom: 0 }}
        className={classes.section}
      >
        <h2 className={classes.title} style={{ paddingBottom: 15 }}>
          Our Partners
        </h2>
        <h5 style={{ paddingBottom: 10 }} className={classes.description}>
          At Amedia Networks Limited, our strength lies in the strategic
          partnerships we have built with some of the most prestigious names in
          the media industry. These collaborations enable us to offer a diverse
          and premium content library, ensuring our clients have access to
          world-class entertainment.
        </h5>
        <h3 className={classes.title} style={{ paddingBottom: 15 }}>
          Our Esteemed Partners
        </h3>
        <GridContainer>
          {partners.map((partner) => (
            <GridItem
              key={partner.name}
              className={classes.topSpace}
              xs={12}
              sm={6}
              md={4}
            >
              <p
                className={classes.title}
                style={{ paddingBottom: 15, marginTop: 0 }}
              >
                {partner.name}{" "}
                <a href={partner.url} target="_blank" rel="noopener noreferrer">
                  <i className={classes.socialIcons + " fa-solid fa-link"} />
                </a>
              </p>
            </GridItem>
          ))}
        </GridContainer>
        <h3 className={classes.title} style={{ paddingBottom: 15 }}>
          Expanding Our Network
        </h3>
        <h5 style={{ paddingBottom: 10 }} className={classes.description}>
          Our partnerships don’t stop here. We continue to create relationships
          with new partners worldwide, including in key markets such as the USA,
          UK, France, Germany, Japan, and Canada. These ongoing collaborations
          ensure that our content library remains diverse, dynamic, and
          reflective of global entertainment trends.
          <br />
          <br />
          By working with the best in the industry, Amedia Networks Limited
          remains at the forefront of delivering premium entertainment to
          audiences around the world.
        </h5>
      </div>
    );
  }
}

export default withStyles(productStyle)(PartnersSection);
